import React from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ImageDialog from './_components/ImageDialog';
import Image11 from './_style/solar1_1.jpg';
import Image12 from './_style/solar1_2.jpg';
import Image13 from './_style/solar1_3.jpg';
import Image14 from './_style/solar1_4.jpg';
import Image21 from './_style/solar2_1.jpg';
import Image22 from './_style/solar2_2.jpg';
import Image23 from './_style/solar2_3.jpg';
import Image24 from './_style/solar2_4.jpg';
import Image41 from './_style/solar4_1.jpg';
import Image42 from './_style/solar4_2.jpg';
import Image51 from './_style/solar5_1.jpg';
import Image61 from './_style/solar6_1.jpg';
import { isMobile } from 'react-device-detect';

export function Default2() {
  const { t } = useTranslation();

  const [showImage, setShowImage] = React.useState(false);
  const [curImage, setCurImage] = React.useState(null);
  const [imgText, setImgText] = React.useState(null);

  //TODO: info@trybook.com.au

  return (
    <>
    <ImageDialog show={showImage} image={curImage} text={imgText} handleClose={() => setShowImage(false)} />

    <p className="lead">The past 12+ year strenuous work with 800+ solar project delivery is our confidence to ensure your project success. We have the highlights below that other peers might shun:</p>
    <ul>
      <li className="li-text">Respectful and solid 8 years of first-hand solar racking system design & development. We love the truth as revealed by science.
        <div class="container ">
          <div class="row align-items-start">
            <img src={Image11} onClick={() =>{setShowImage(true); setCurImage(Image11); setImgText(""); } } alt="..." className="col-2 col-md-1 me-4 "  />
            <img src={Image12} onClick={() =>{setShowImage(true); setCurImage(Image12); setImgText(""); } } alt="..." className="col-2 col-md-1 bd-placeholder-img me-4"  />
            <img src={Image13} onClick={() =>{setShowImage(true); setCurImage(Image13); setImgText(""); } } alt="..." className="col-2 col-md-1 bd-placeholder-img me-4"  />
            <img src={Image14} onClick={() =>{setShowImage(true); setCurImage(Image14); setImgText(""); } } alt="..." className="col-2 col-md-1 bd-placeholder-img "  />   
            {/* <img src={Image11} alt="..." className="col-sm-12 col-md-6 bd-placeholder-img "  />
            <img src={Image12} alt="..." className="col-sm-12 col-md-6 bd-placeholder-img "  />
            <img src={Image13} alt="..." className="col-sm-12 col-md-6 bd-placeholder-img "  />
            <img src={Image14} alt="..." className="col-sm-12 col-md-6 bd-placeholder-img "  />            */}
          </div>
        </div>
      </li>
      <li className="li-text">Passionate on hardcore projects in searching the sound solution. We love challenges.
        <div class="container ">
          <div class="row align-items-start">
            <img src={Image21} onClick={() =>{setShowImage(true); setCurImage(Image21); setImgText(""); } } alt="..." className="col-2 col-md-1 me-4 "   />
            <img src={Image22} onClick={() =>{setShowImage(true); setCurImage(Image22); setImgText(""); } }  alt="..."  className="col-2 col-md-1 me-4 "   />                  
          </div>
        </div>
      </li>
      <li className="li-text">Per the building code, but work beyond the code. We love apply engineering ingenuity.
        <div class="container">
          <div class="row align-items-start">
            <img src={Image23} onClick={() =>{setShowImage(true); setCurImage(Image23); setImgText(""); } } alt="..." className="col-2 col-md-1 me-4 "  />
            <img src={Image24} onClick={() =>{setShowImage(true); setCurImage(Image24); setImgText(""); } } alt="..." className="col-2 col-md-1 bd-placeholder-img "  />                
          </div>
        </div>
      </li>
      <li className="li-text">We love showcases of public solar facility.
        <div class="container ">
          <div class="row align-items-start">
            <img src={Image41} onClick={() =>{setShowImage(true); setCurImage(Image41); setImgText("280KW Milpitas BART station solar canopy, Milpitas, CA (service to Staten Solar Corp.)"); } } 
              alt="..." className="col-2 col-md-1 me-4 "  />
            <img src={Image42} onClick={() =>{setShowImage(true); setCurImage(Image42); setImgText("EOR (Engineer of Record) of two 1.5MW solar farm projects in Apply Valley, CA (service to Belectric Inc.)"); } }
              alt="..." className="col-2 col-md-1 bd-placeholder-img "  />   
          </div>
        </div>
      </li>
      <li className="li-text">We love automation and streamline work procedure to use less to produce more.
        <div class="container ">
          <div class="row align-items-start">
            <img src={Image51} onClick={() =>{setShowImage(true); setCurImage(Image51); setImgText("Write ANSYS APDL program (as shown on the left) to automate the ground mounted racking system FEA analysis, including member geometric modelling, load application, boundary condition assignment, FEA meshing, member FEA analysis, and result (stress/reactions) sorting/exporting (all steps automated) ."); } } 
            alt="..." className="col-2 col-md-1 me-4 "  />               
          </div>
        </div>
      </li>
      <li className="li-text">We love to see you would love our work. That is all we work for.
        <div class="container ">
          <div class="row align-items-start">
            <img src={Image61} alt="..." className="col-sm-12 col-md-8 bd-placeholder-img "  />
            <div class="col-sm-12 col-md-4"  >
              <span className="explain-text">Hold engineering licenses in all green states plus Hawaii. </span>
            </div>            
              
          </div>
        </div>
      </li>
    </ul>
    <div class="row w-100">
      <span className={ isMobile?"w-50":"w-75"}> </span>
      <Link to="/quote" className={ isMobile?"w-50":"w-25"}>Request a quote now...</Link>
    </div>
    
    <div id="myCarousel" className="carousel slide invisible" >      {/* data-bs-ride="carousel" */}
    <div className="carousel-indicators">
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
    </div>
    <div className="carousel-inner">
      <div className="carousel-item active">
      <svg className="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#777"/></svg>

      
        <div className="container">
       
          <div className="carousel-caption text-start">
            <p>Respectful and solid 8 years of first-hand solar racking system design & development. We love the truth as revealed by science. </p>
            {/* <p><a className="btn btn-lg btn-primary" href="#">Sign up today</a></p> */}
          </div>
        </div>
      </div>
      <div className="carousel-item">
        <svg className="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#777"/></svg>

        <div className="container">
          <div className="carousel-caption">
            <h1>Another example headline.</h1>
            <p>Some representative placeholder content for the second slide of the carousel.</p>
            {/* <p><a className="btn btn-lg btn-primary" href="#">Learn more</a></p> */}
          </div>
        </div>
      </div>
      <div className="carousel-item">
        <svg className="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#777"/></svg>

        <div className="container">
          <div className="carousel-caption text-end">
            <h1>One more for good measure.</h1>
            <p>Some representative placeholder content for the third slide of this carousel.</p>
            {/* <p><a className="btn btn-lg btn-primary" href="#">Browse gallery</a></p> */}
          </div>
        </div>
      </div>
    </div>
    <button className="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Previous</span>
    </button>
    <button className="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
      <span className="carousel-control-next-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Next</span>
    </button>
  </div>
  </>
  );
}